/** @format */

import React from 'react';
import { css } from '@emotion/core';
import { FadeLoader } from 'react-spinners';
import { connect } from 'react-redux';
import Directions from '../directions/directions';
import TestField from '../../components/test-field/test-field';
import SessionStorage from '../../../api/session-storage';
import Requests from '../../../api/requests';
import Modal from '../../components/modal/modal';
import PopupOneButton from '../../components/popup/popup-one-button';
import { selectKey } from '../../../utilities/helper';
import { bindActionCreators } from 'redux';
import { receivedLogUserIn } from '../../../store/actions/user-actions';
import './test-launcher.scss';
import Timer from '../../components/timer/Timer';
import { messages } from '../../../text/text';
import { TEST_ENGINE_PSIUTD } from '../../../api/types';
import _ from 'lodash';
import moment from 'moment';
const MINUTE = 60 * 1000;

const mapStateToProps = state => ({
  ...state,
});
const mapDispatchToProps = dispatch => {
  return bindActionCreators({ receivedLogUserIn }, dispatch);
};

let auto_launch_timings = [];
let testTimeBoundaries = {},
  nonTestTimeBoundaries = {};

class TestLauncher extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedIndex: null,
      directions: '',
      assessments: [],
      modalIsOpen: false,
      isSequential: false,
      index: 0,
      ids: [],
      allComplete: false,
      lastTestTerminated: false,
      hasInvalidParams: false,
      loading: false,
      hasContent: false,
      hasUrlError: false,
      hasOtherAssessmentInLaunch: false,
      hasInvalidAuthParams: false,
      urlErrorMessage: '',
      launchedAssessmentExistsErrorMessage: '',
      autoLaunch: false,
      testsToBeLaunched: [],
      nrOfCompletedTests: 0,
      nrOfLaunchedTests: 0,
      nrOfSeconds: -1,
      tlp_params: {},
      timing_modifier: 1,
      invalidLaunchTime: false,
      now: null,
      timezone: '',
    };
  }

  getQueryStringParams = searchParams => {
    let params = {};
    let queryParamArray = searchParams.split('&');
    queryParamArray.forEach(function (queryParam) {
      let item = queryParam.split('=');
      if (item[0] === 'lti_log') {
        item[1] = decodeURIComponent(item[1]).replace(/\+/g, ' ');
      }
      params[item[0]] = decodeURIComponent(item[1]);
    });
    return params;
  };

  determineStatusForLaunchEngineTAO = params => {
    let status;
    switch (params.lti_msg) {
      case 'Finished':
        status = 'C';
        break;
      case 'Paused':
      case 'Active':
      case 'Awaiting':
      case 'Authorized':
        status = 'L';
        break;
      case 'Terminated':
        status = 'T';
        break;
      case 'Canceled':
      default:
        status = '';
    }

    let ltiErrorMsg;
    let ltiErrorPrefix =
      'Sorry an error has occurred.  Please contact your proctor.  Error message: ';
    let ltiLog = params.lti_log || 'NORMAL';
    var decodedltiErrorMsg = decodeURIComponent(params.lti_errormsg).replace(
      /\+/g,
      ' ',
    );
    switch (decodedltiErrorMsg) {
      case 'Error: Undefined LTI variable lti_message_type':
        ltiErrorMsg = ltiErrorPrefix + 'Message type is empty or not defined.';
        break;
      case 'Error: Invalid LTI message type provided.':
        ltiErrorMsg = ltiErrorPrefix + 'Message type is not valid.';
        break;
      case 'Error: Undefined LTI variable lti_version':
        ltiErrorMsg = ltiErrorPrefix + 'LTI version is empty or not defined.';
        break;
      case 'Error: Wrong LTI version provided.':
        ltiErrorMsg = ltiErrorPrefix + 'LTI version is wrong.';
        break;
      case 'Error: Invalid LTI version provided.':
        ltiErrorMsg = ltiErrorPrefix + 'LTI version is not valid.';
        break;
      case 'Error: Undefined LTI variable resource_link_id':
        ltiErrorMsg = ltiErrorPrefix + 'Resource ID is empty or not defined.';
        break;
      case 'Error: Undefined LTI variable user_id':
        ltiErrorMsg = ltiErrorPrefix + 'User ID is empty or not defined.';
        break;
      case 'Error (0): Access to this functionality is restricted to students':
        ltiErrorMsg = ltiErrorPrefix + 'Role is not value of Learner.';
        break;
      case 'Error: Attempts limit has been reached.':
        ltiErrorMsg =
          'Sorry this test section was previously completed, please attempt another test section.  If this is incorrect, please contact your proctor.';
        status = 'C';
        break;
      case 'Error: "max_attempts" variable must me numeric.':
        ltiErrorMsg =
          ltiErrorPrefix + '"max_attempts" variable must be numeric.';
        break;
      case 'Error: Client does not comply to the delivery execution':
        ltiErrorMsg =
          ltiErrorPrefix + 'Browser or Operating System is not supported.';
        break;
      default:
        ltiErrorMsg = '';
    }

    return { status, ltiErrorMsg, ltiLog, decodedltiErrorMsg };
  };

  determineStatusForLaunchEnginePSIUTD = params => {
    let status;
    switch (params.lti_msg) {
      case 'completed':
        status = 'C';
        break;
      case 'terminated':
      case 'auto-terminated':
        status = 'T';
        break;
      default:
        status = '';
    }

    let ltiLog = params.lti_msg || 'NORMAL';
    return { status, ltiErrorMsg: '', ltiLog, decodedltiErrorMsg: '' };
  };

  componentDidMount = async () => {
    if (this.props.userStore.hasUserLoggedOut || !this.props.userStore.admin) {
      this.setState({
        hasInvalidAuthParams: true,
      });
      return;
    }
    window.addEventListener('keydown', this.keySelect);
    const admin = this.props.userStore.admin;
    const user = {
      admin_id: admin.admin_id,
      reg_id: admin.reg_id,
      token: admin.token,
    };
    let launchDetails = {};
    setTimeout(() => {
      this.setState({
        loading: true,
      });
    }, 400);

    let params = {};
    let searchParams = '';

    if (window.location.search) {
      searchParams = window.location.search;
      searchParams = searchParams.substr(1);
      params = this.getQueryStringParams(searchParams);

      //This covers only TAO case.
      launchDetails = this.determineStatusForLaunchEngineTAO(params);
    }
    if (params.tde_session && params.launch_engine === TEST_ENGINE_PSIUTD) {
      //This is the case of PSI UTD assume test is always complete
      //when there is a tde_session in the url string as it will appear there only when
      //it is returned from PSI UTD
      launchDetails = this.determineStatusForLaunchEnginePSIUTD(params);
    }
    if (Object.keys(params).length > 0) {
      if (launchDetails.status) {
        let requestBody = {
          admin_id: params.admin_id,
          label: params.label,
          requester: 'PORTAL',
          reason: launchDetails.ltiLog,
          status: launchDetails.status,
          lti_return_parameters: searchParams,
        };
        if (params.test_launch_id) {
          requestBody.test_launch_id = parseInt(params.test_launch_id);
        }
        if (params.tde_session) {
          requestBody.tde_session = params.tde_session;
        }
        const { ok: okPut, status: statusPut } = await Requests.putAssessment(
          JSON.stringify(requestBody),
          admin.reg_id,
          admin.token,
        );
        if (okPut) {
          if (statusPut === 204) {
            if (launchDetails.ltiErrorMsg) {
              this.setState({
                hasUrlError: true,
                urlErrorMessage: launchDetails.ltiErrorMsg,
              });
            }
            this.getAssessments(user);
          }
        } else {
          if (statusPut === 400 || statusPut === 403) {
            this.setState({ hasInvalidParams: true });
          }
        }
      } else if (launchDetails.ltiErrorMsg) {
        this.setState({
          hasUrlError: true,
          urlErrorMessage: launchDetails.ltiErrorMsg,
        });
        let auditItem = {
          registration_id: admin.reg_id,
          admin_id: params.admin_id,
          function: 'TEST',
          action: 'LAUNCH',
          result: 'FAIL',
          label: params.label,
          requester: 'launchportal-ui',
          reason: launchDetails.decodedltiErrorMsg,
          lti_return_parameters: searchParams,
        };
        Requests.postHistory(JSON.stringify(auditItem), admin.token);
        this.getAssessments(user);
      } else {
        this.getAssessments(user);
      }
    } else {
      if (!user || !user.admin_id) {
        this.setState({
          hasInvalidAuthParams: true,
        });
      } else {
        this.getAssessments(user);
      }
    }
    if (_.get(this.props, 'userStore.user.tlp_params')) {
      this.setState({
        tlp_params: this.props.userStore.user.tlp_params,
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(prevProps, this.props) &&
      _.get(this.props, 'userStore.user.tlp_params')
    ) {
      this.setState({
        tlp_params: this.props.userStore.user.tlp_params,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keySelect);
    clearInterval(this.intervalID);
  }

  tick() {
    const newTime = this.state.now.utc() + MINUTE;
    this.setState({
      now: moment(newTime).zone(this.state.timezone),
    });
  }

  addZero(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }

  displayTime(d) {
    var h = this.addZero(d.hours());
    var m = this.addZero(d.minutes());
    return h > 12 ? `${h - 12}:${m} p.m.` : `${h}:${m} a.m.`;
  }

  getAssessments = async user => {
    const { ok, json: body, status } = await Requests.getAssessments(user);
    if (ok) {
      if (status === 200) {
        const user = this.props.userStore.user;
        let assessments = body.assessments;
        this.intervalID = setInterval(() => this.tick(), MINUTE);
        let tz = body.server_tz;
        if (tz.indexOf(':') === 2) {
          tz = tz.slice(0, 1) + '0' + tz.slice(1);
        }
        tz = tz === 'local' ? '' : tz;
        this.setState(
          {
            assessments: assessments.sort(
              (a, b) =>
                parseFloat(a.display_order_id) - parseFloat(b.display_order_id),
            ),
            loading: false,
            hasContent: true,
            directions: body.directions,
            autoLaunch: user.auto_launch_ind === true,
            ...this.filterAssessments(assessments),
            timing_modifier: this.props.userStore.user.timing_modifier
              ? this.props.userStore.user.timing_modifier
              : 1,
            now: assessments && moment(body.server_utc * 1000).zone(tz),
            timezone: tz,
          },
          () => {
            let ids = [];
            let i = 0;
            this.state.assessments.forEach(assesment => {
              if (assesment.status_fl === 'A' || assesment.status_fl === 'L') {
                i++;
                ids.push(`test-field-${i}`);
              }
            });
            ids.push('logout');
            this.setState({ ids: ids });
            if (
              this.state.assessments.every(field => field.status_fl === 'C')
            ) {
              this.setState({
                allComplete: true,
              });
            }
            if (
              this.state.lastCompletedTest?.status_fl === 'T' &&
              this.state.testsToBeLaunched.length === 0
            ) {
              this.setState({
                lastTestTerminated: true,
              });
            }
            this.setTimer();
          },
        );
      }
      if (status === 204) {
        this.setState({
          allComplete: true,
          loading: false,
          hasContent: true,
        });
      }
    } else {
      if (status === 400 || status === 403) {
        this.setState({ hasInvalidParams: true });
      }
    }
  };

  filterAssessments = assessments => {
    let availableSections = [],
      completedSections = [],
      launchedSections = [];
    for (let i = 0; i < assessments.length; i++) {
      switch (assessments[i].status_fl) {
        case 'A':
          availableSections.push(assessments[i]);
          break;
        case 'C':
          completedSections.push(assessments[i]);
          break;
        case 'T':
          completedSections.push(assessments[i]);
          break;
        case 'L':
          launchedSections.push(assessments[i]);
          break;
        default:
          break;
      }
    }

    return {
      nrOfAvailableTests: availableSections.length,
      nrOfLaunchedTests: launchedSections.length,
      nrOfCompletedTests: completedSections.length,
      lastCompletedTest:
        completedSections.length > 0
          ? completedSections[completedSections.length - 1]
          : undefined,
      testsToBeLaunched: availableSections.sort((a, b) =>
        a.seq_id > b.seq_id
          ? 1
          : b.seq_id > a.seq_id
            ? -1
            : a.display_order_id > b.display_order_id
              ? 1
              : b.display_order_id > a.display_order_id
                ? -1
                : 0,
      ),
    };
  };

  setTimer = () => {
    if (_.get(this.props, 'userStore.user.tlp_params.auto_launch_timings')) {
      auto_launch_timings =
        this.props.userStore.user.tlp_params.auto_launch_timings;
      if (SessionStorage.getStopTime()) {
        const stopTime = moment(SessionStorage.getStopTime());
        const now = moment();
        if (stopTime.isBefore(now)) {
          SessionStorage.removeStopTime();
          this.startTimer();
        } else {
          const nrOfSeconds = stopTime.isBefore(now)
            ? 0
            : Math.ceil((stopTime - now) / 1000);
          this.startTimer(nrOfSeconds);
        }
      } else {
        if (this.checkAutoLaunch()) {
          this.startTimer();
        }
      }
    }
  };

  startTimer = (
    nrOfSeconds = auto_launch_timings[this.state.nrOfCompletedTests - 1],
  ) => {
    SessionStorage.saveStopTime(moment().add('seconds', nrOfSeconds));
    this.setState({
      nrOfSeconds,
    });
  };

  checkAutoLaunch = () => {
    const firstTestToBeLaunched =
      this.state.testsToBeLaunchedlength > 0
        ? this.state.testsToBeLaunched[0]
        : {};
    const isNonTestSection = this.state.tlp_params.non_test_sections
      ? this.state.tlp_params.non_test_sections.indexOf(
          firstTestToBeLaunched.seq_id,
        ) > -1
      : false;
    return (
      auto_launch_timings.length > 0 &&
      this.state.autoLaunch &&
      this.state.nrOfLaunchedTests === 0 &&
      this.state.nrOfCompletedTests > 0 &&
      this.state.assessments.length !== this.state.nrOfCompletedTests &&
      this.state.testsToBeLaunched.length > 0 &&
      ((isNonTestSection &&
        this.state.now.isBefore(nonTestTimeBoundaries.not_after_end)) ||
        (!isNonTestSection &&
          this.state.now.isBefore(testTimeBoundaries.not_after_end)))
    );
  };

  setTimeBoundaries = (firstTestToBeLaunched, field) => {
    const { nrOfSeconds } = this.state;
    const launchedIn =
      firstTestToBeLaunched &&
      firstTestToBeLaunched.test_launch_id === field.test_launch_id &&
      this.checkAutoLaunch() &&
      nrOfSeconds > -1
        ? { autoLaunchIn: nrOfSeconds }
        : {};
    const isNonTestSection = this.isNonTestSection(field);
    const timingBoundaries =
      this.state.nrOfCompletedTests > 0
        ? {
            notAfterEnd: isNonTestSection
              ? nonTestTimeBoundaries.not_after_end
              : testTimeBoundaries.not_after_end,
            timezone: isNonTestSection
              ? this.state.tlp_params['non-test_section_launch_time_range']
                  .not_after_end_tz
              : this.state.tlp_params['test_section_launch_time_range']
                  .not_after_end_tz,
          }
        : {
            notBeforeEarly: isNonTestSection
              ? nonTestTimeBoundaries.not_before_early
              : testTimeBoundaries.not_before_early,
            notAfterEarly: isNonTestSection
              ? nonTestTimeBoundaries.not_after_early
              : testTimeBoundaries.not_after_early,
            timezone: isNonTestSection
              ? this.state.tlp_params['non-test_section_launch_time_range']
                  .not_before_early_tz
              : this.state.tlp_params['test_section_launch_time_range']
                  .not_before_early_tz,
          };

    return {
      launchedIn,
      timingBoundaries,
    };
  };

  isNonTestSection = section => {
    return (
      this.state.tlp_params.non_test_sections &&
      this.state.tlp_params.non_test_sections.indexOf(section.seq_id) > -1
    );
  };

  setIndex = index => {
    this.setState({ index: index });
  };

  keySelect = event => {
    let ids = this.state.ids;
    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    const isModalOpen = this.props.headerStore.isModalOpen;
    if (
      this.state.index <= ids.length - 1 &&
      this.state.index >= 0 &&
      !isModalOpen
    ) {
      selectKey(
        event,
        this.state.index,
        ids,
        focusedElement,
        this.setIndex,
        arrows,
      );
    }
  };

  exit = () => {
    const user = SessionStorage.getUser();
    if (user.delivery_type.toLowerCase() === 'remote') {
      this.props.history.push('/remote/login');
    }
    if (user.delivery_type.toLowerCase() === 'center') {
      this.props.history.push('/center/login');
    }
    SessionStorage.clearStorage();
    const { receivedLogUserIn } = this.props;
    receivedLogUserIn(false);
  };

  closeErrorModal = () => {
    const user = SessionStorage.getUser();
    if (user && user.delivery_type.toLowerCase() === 'remote') {
      this.props.history.push('/remote/login');
    }
    if (user && user.delivery_type.toLowerCase() === 'center') {
      this.props.history.push('/center/login');
    }
    if (!user) {
      this.props.history.push('/center/login');
    }
    SessionStorage.clearStorage();
  };

  closeInvalidAuthModal = () => {
    SessionStorage.clearStorage();
    this.props.history.push('/');
  };

  closeUrlErrorModal = () => {
    this.setState({ hasUrlError: false });
  };

  checkIfOtherAssessmentLaunchExists = field => {
    // eslint-disable-next-line
    for (let assessment of this.state.assessments) {
      if (
        assessment.status_fl === 'L' &&
        field.test_launch_id !== assessment.test_launch_id
      ) {
        this.setState({
          hasOtherAssessmentInLaunch: true,
          launchedAssessmentExistsErrorMessage: `You must complete "${assessment.label}" before launching a new test.`,
        });
        return true;
      }
    }
    return false;
  };

  getOrderNumber = () => {
    const { assessments } = this.state;
    let nr = 1;
    for (let i = 0; i < assessments.length; i++) {
      if (
        assessments[i].status_fl === 'T' ||
        assessments[i].status_fl === 'C'
      ) {
        nr++;
      }
    }
    return nr;
  };

  closeLaunchErrorModal = () => {
    this.setState({ hasOtherAssessmentInLaunch: false });
  };

  getMoment(timeString) {
    const time = timeString.split(':').map(elem => parseInt(elem));
    return moment({
      hour: time[0],
      minute: time[1],
      seconds: time[2],
    });
  }

  getTimeBoundaries = section => {
    const { not_before_early, not_after_early, not_after_end } =
      this.state.tlp_params[section];

    let end;
    let remainder;
    let remainingMinutes;

    if (section !== 'non-test_section_launch_time_range') {
      end = this.getMoment(not_after_end).subtract(
        'seconds',
        this.state.tlp_params.standard_section_buffer_duration *
          this.state.timing_modifier,
      );
    } else {
      end = this.getMoment(not_after_end);
    }

    remainingMinutes = end.minute() % 5;
    remainder = remainingMinutes && 5 - remainingMinutes;

    return {
      not_before_early: this.getMoment(not_before_early),
      not_after_early: this.getMoment(not_after_early),
      not_after_end: moment(end).add('minutes', remainder),
    };
  };

  setInvalidLaunchTime = invalidTimeMessage => {
    this.setState({
      invalidLaunchTime: true,
      invalidTimeMessage,
    });
  };

  closeInvalidLaunchTimeModal = () => {
    this.setState({
      invalidLaunchTime: false,
    });
  };

  render() {
    let fields = this.state.assessments;
    const allComplete = this.state.allComplete;
    const lastTestTerminated = this.state.lastTestTerminated;
    let i = 0;
    const admin = this.props.userStore.admin;
    const override = css`
      display: block;
      margin: 0 auto;
    `;
    const firstTestToBeLaunched =
      this.state.testsToBeLaunched.length > 0
        ? this.state.testsToBeLaunched[0]
        : {};
    const { nrOfSeconds } = this.state;

    if (_.get(this.state, 'tlp_params.test_section_launch_time_range')) {
      testTimeBoundaries = this.getTimeBoundaries(
        'test_section_launch_time_range',
      );
      nonTestTimeBoundaries = this.getTimeBoundaries(
        'non-test_section_launch_time_range',
      );
    }

    return this.state.hasContent ? (
      <>
        <main className="test-launcher">
          {_.get(this.props, 'userStore.user.delivery_type') &&
          this.props.userStore.user.delivery_type === 'Remote' &&
          _.get(this.props, 'userStore.user.tlp_params') ? (
            <div aria-label="Timing Information">
              <div aria-label={`${messages.currentTime}`}>
                <span className="timing_info">{messages.currentTime}:</span>{' '}
                <span className="App-clock">{`${this.displayTime(
                  this.state.now,
                )}`}</span>
              </div>
              {this.checkAutoLaunch() && !allComplete && nrOfSeconds > 0 && (
                <>
                  <div aria-label={`${messages.warningNextSection}`}>
                    <span className="warning timing_info">
                      {messages.warningNextSection}:
                    </span>{' '}
                    <Timer seconds={this.state.nrOfSeconds} />
                  </div>
                  <div aria-label={`${messages.launchManually}`}>
                    ({messages.launchManually})
                  </div>
                </>
              )}
            </div>
          ) : (
            ''
          )}
          <div className="test-launcher-heading" tabIndex={0} autoFocus={true}>
            <h1 className="title">ACT Tests</h1>
          </div>
          <p className="description">
            The buttons will be made available as you work your way through the
            assessment. If multiple buttons are available, you may click on any
            of them to begin that section.
          </p>
          <div className="directions">
            {this.state.directions && (
              <React.Fragment>
                <br /> <Directions />
              </React.Fragment>
            )}
          </div>
          {!allComplete && (
            <div className="fields-container">
              {fields.map(field => {
                if (field.status_fl === 'A' || field.status_fl === 'L') {
                  i++;
                }
                const { launchedIn, timingBoundaries } =
                  !allComplete && !_.isEqual(this.state.tlp_params, {})
                    ? this.setTimeBoundaries(firstTestToBeLaunched, field)
                    : {};
                return (
                  <TestField
                    key={field.test_launch_id}
                    field={field}
                    isSequential={this.state.isSequential}
                    index={
                      (field.status_fl === 'A' || field.status_fl === 'L') && i
                    }
                    token={admin.token}
                    admin={admin.admin_id}
                    regId={admin.reg_id}
                    rp_session_status_retry_duration={
                      this.props.userStore.user.rp_session_status_retry_duration
                    }
                    rp_session_status_retry_limit={
                      this.props.userStore.user.rp_session_status_retry_limit
                    }
                    checkIfOtherAssessmentLaunchExists={
                      this.checkIfOtherAssessmentLaunchExists
                    }
                    getOrderNumber={this.getOrderNumber}
                    setInvalidLaunchTime={this.setInvalidLaunchTime}
                    {...launchedIn}
                    {...timingBoundaries}
                    now={this.state.now}
                  />
                );
              })}
            </div>
          )}
          <Modal
            isOpen={this.state.invalidLaunchTime}
            closeModal={this.closeInvalidLaunchTimeModal}
            className={'modal-content one-button'}
            child={
              <PopupOneButton
                title="Error"
                description={this.state.invalidTimeMessage}
                buttonText="OK"
                padding="0 70px"
                onClick={this.closeInvalidLaunchTimeModal}
              />
            }
          />
          <Modal
            isOpen={allComplete}
            closeModal={this.closeModal}
            className={'modal-content one-button'}
            child={
              <PopupOneButton
                title="Congratulations"
                description="All tests have been completed"
                buttonText="Exit"
                padding="0 70px"
                onClick={this.exit}
              />
            }
          />
          <Modal
            isOpen={lastTestTerminated}
            closeModal={this.closeModal}
            className={'modal-content one-button'}
            child={
              <PopupOneButton
                title="Terminated"
                description="Your test has been terminated."
                buttonText="Exit"
                padding="0 70px"
                onClick={this.exit}
              />
            }
          />
          <Modal
            isOpen={this.state.hasInvalidParams}
            className={'modal-content one-button'}
            child={
              <PopupOneButton
                title="Error"
                description="Something went wrong. Please try again"
                buttonText="Go To Sign In"
                padding="0 75px"
                onClick={this.closeErrorModal}
              />
            }
          />
          <Modal
            isOpen={this.state.hasUrlError}
            closeModal={this.closeUrlErrorModal}
            className={'modal-content one-button'}
            child={
              <PopupOneButton
                title="Error"
                description={this.state.urlErrorMessage}
                buttonText="Exit"
                padding="0 70px"
                onClick={this.closeUrlErrorModal}
              />
            }
          />
          <Modal
            isOpen={this.state.hasOtherAssessmentInLaunch}
            closeModal={this.closeLaunchErrorModal}
            className={'modal-content one-button'}
            child={
              <PopupOneButton
                title="Error"
                description={this.state.launchedAssessmentExistsErrorMessage}
                buttonText="OK"
                padding="0 70px"
                onClick={this.closeLaunchErrorModal}
              />
            }
          />
        </main>
      </>
    ) : (
      <>
        <div
          className="spinner-container"
          role="alert"
          aria-label="Please wait, the page is getting loaded."
        >
          <FadeLoader
            css={override}
            size={'350px'}
            sizeUnit="px"
            color="#042E60"
            loading={this.state.loading}
            height={30}
            width={7}
            margin={20}
          />
        </div>
        <Modal
          isOpen={this.state.hasInvalidAuthParams}
          className={'modal-content one-button'}
          child={
            <PopupOneButton
              title="Error"
              description="You need to be logged in to access this page."
              buttonText="Go To Sign In"
              padding="0 75px 30px"
              onClick={this.closeInvalidAuthModal}
            />
          }
        />
        <Modal
          isOpen={this.state.hasInvalidParams}
          className={'modal-content one-button'}
          child={
            <PopupOneButton
              title="Error"
              description="Something went wrong. Please try again"
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closeErrorModal}
            />
          }
        />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TestLauncher);
